import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Bank } from "../@types";

interface AlertBankRaw {
  BankCode?: string;
  BankName?: string;
  Code?: string;
  Name?: string;
  ID?: string;
  [key: string]: unknown;
}

function useBankList(
  options?: QueryObserverOptions<APIResponse<Bank[]>, APIError>
) {
  const {
    data: bankListData,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Bank[]>, APIError>(
    "bank_list",
    async () => {
      const res = await get(
        API_URL + "/account/wallet/transfer/alert-banks",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // Normalize Alert's PascalCase response to match our Bank interface
      const raw: AlertBankRaw[] = res.data ?? [];
      const normalized: Bank[] = raw.map((b, i) => {
        const name = b.BankName ?? b.Name ?? "";
        const code = b.BankCode ?? b.Code ?? "";
        return {
          id: Number(b.ID ?? i),
          code,
          name,
          slug: name.toLowerCase().replace(/\s+/g, "-"),
          logo: "",
          longcode: "",
          longCode: "",
          active: true,
          country: "NG",
          currency: "NGN",
          type: "nuban",
          created: "",
          pay_with_bank: false,
          supports_transfer: true,
          is_deleted: false,
          createdAt: "",
          updatedAt: "",
        };
      });

      return { ...res, data: normalized };
    },
    options
  );

  return {
    bankListData,
    isError,
    error,
    isLoading,
  };
}

export default useBankList;
